/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import { post, get } from 'embercom/lib/ajax';

import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { IntegrationState } from 'embercom/objects/standalone/constants';
import { action } from '@ember/object';
const API_ROOT = '/ember/standalone/salesforce_configurations';
const FIN_REQUIRED_PERMISSIONS_PACKAGE_URL =
  'https://login.salesforce.com/packaging/installPackage.apexp?p0=04tgK00000014Sz';

export default class SalesforceConfiguration extends Model {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: $TSFixMe;

  @attr('string') declare instanceUrl: string;
  @attr('boolean') declare isSandbox: boolean;
  @attr('number') declare workflowRulesetId: number;
  @attr('string') declare organisationId: string | undefined;
  @attr('string') declare supportEmail: string | undefined;

  @attr('string')
  declare finSalesforceUserId: string | undefined;

  @attr('number', { defaultValue: IntegrationState.NotConfigured })
  declare status: IntegrationState;

  get isPendingSetup() {
    return this.status === IntegrationState.NotConfigured;
  }

  get isConnected() {
    return !this.isPendingSetup;
  }

  get isEnabled() {
    return this.status === IntegrationState.Enabled;
  }

  get readyToSetLive() {
    return this.isConnected && this.finSalesforceUserId;
  }

  get environmentLabel() {
    return this.isSandbox ? 'sandbox' : 'production';
  }

  get domain() {
    return this.instanceUrl.replace('https://', '');
  }

  @action async getUsageCounts(): Promise<{
    involvement_count: number;
    last_active?: string;
  }> {
    return get(`${API_ROOT}/${this.id}/usage_counts`);
  }

  async setFinUser(finSalesforceUserId: string) {
    await post(`${API_ROOT}/${this.id}/set_fin_salesforce_user`, {
      fin_salesforce_user_id: finSalesforceUserId,
    });

    this.finSalesforceUserId = finSalesforceUserId;
  }

  async activateForCases() {
    await post(`${API_ROOT}/${this.id}/activate`);
    await this.reload();
  }

  async deactivateForCases() {
    await post(`${API_ROOT}/${this.id}/deactivate`);
    await this.reload();
  }

  async disconnectApp() {
    await post(`${API_ROOT}/${this.id}/disconnect`);
    this.instanceUrl = '';
    this.status = IntegrationState.NotConfigured;
  }

  async setSupportEmail(supportEmail: string) {
    let response = await post(`${API_ROOT}/${this.id}/set_support_email`, {
      support_email: supportEmail,
    });
    await this.reload();
    return response;
  }

  get finRequiredPermissionsUrl() {
    return FIN_REQUIRED_PERMISSIONS_PACKAGE_URL;
  }
}
